module.exports = __webpack_public_path__ + "img/attence.6083bdec.svg";